import { Fragment, useEffect, useState } from 'react';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { jobStatusData, JobStatusRes } from '../JobStatus/data/jobStatus';
import { infoTracUser } from '../../../../contstant';
import DataTable from '../../../../components/Common/UI/DataTable';
import WrapperCard from '../../Common/WrapperCard';
import Link from '../../../../components/Common/UI/Link';
import { messageManagerData, MessageManagerRes } from './data/messageManager';
import Icons from '../../../../components/Common/Icons/Icons';
import { Button } from '../../../../components/Common/UI/Button';
import Separator from '../../../../components/Common/UI/Separator';
import PageSubHeader from '../../Common/PageSubHeader';
import UpdateProfileDialog from './UpdateProfile';
import { jobColumns, messageManCol } from './columns';

function Dashboard() {
  const [jobData, setJobData] = useState<JobStatusRes[]>([]);
  const [messageManData, setMessageManData] = useState<MessageManagerRes[]>([]);

  useEffect(() => {
    setJobData(jobStatusData);
  }, [jobStatusData]);
  useEffect(() => {
    setMessageManData(messageManagerData);
  }, [messageManagerData]);

  return (
    <div>
      <PageSubHeader
        leftContent={
          <div className="flex items-center gap-2">
            <Icons.Dashboard className="size-6" />
            <span>Dashboard</span>
            <Button size="auto" variant="ghost">
              <Icons.PencilEdit className="size-5 text-addition5" />
            </Button>
          </div>
        }
        breadcrumbs={[
          { path: '/infoTrac', label: <Icons.HomeOutlined />, disableBg: true },
          { path: '/infoTrac', label: 'Dashboard' },
        ]}
      />

      <div className="p-4 grid grid-cols-[1fr_290px] gap-4">
        <div className="">
          <WrapperCard
            label="Job Status"
            extra={
              <Link to="/infoTrac/job-status">
                View All
                <ChevronRightIcon className="font-semibold size-[20px]" />
              </Link>
            }
          >
            <DataTable columns={jobColumns} data={jobData} initialState={{ pagination: { pageSize: 5 } }} />
          </WrapperCard>

          <WrapperCard
            label="Message Manager"
            extra={
              <Link to="/infoTrac/message-manager">
                View All
                <ChevronRightIcon className="font-semibold size-[20px]" />
              </Link>
            }
          >
            <DataTable columns={messageManCol} data={messageManData} initialState={{ pagination: { pageSize: 5 } }} />
          </WrapperCard>
        </div>

        <div>
          <WrapperCard
            label={infoTracUser.userFullName}
            extra={<UpdateProfileDialog />}
            headingContent={
              <div>
                <p>{infoTracUser.company}</p>
                <p>{infoTracUser.email}</p>
              </div>
            }
          >
            <div className="p-4 flex flex-col gap-3">
              {[
                { title: 'Account Coordinator', label: 'Stephen Yee' },
                { title: 'Account Manager', label: 'Phoebe George' },
                { title: 'Account Services Manager', label: 'Phoebe George' },
              ].map(({ title, label }) => (
                <div key={crypto.randomUUID()}>
                  <p className="font-bold">{title}</p>
                  <p className="text-addition2">{label}</p>
                </div>
              ))}
            </div>
          </WrapperCard>

          <WrapperCard label="Knowledge Base">
            <div>
              {[
                {
                  categoryName: 'Message Manager V4',
                  items: [
                    {
                      title: 'Message Manager V4 User Guide',
                      label: 'Download',
                      target: '_blank',
                      url: 'https://infotrac-stage.infoimageinc.com/staticAssets/message_manager_4.0_user_guide.pdf',
                    },
                    {
                      title: 'Message Manager V4 Training Video',
                      label: 'View',
                      url: 'https://www.youtube.com/watch?v=W1cuJxbT5ZU',
                      target: '_blank',
                    },
                  ],
                },
                {
                  categoryName: 'Job Status',
                  items: [
                    {
                      title: 'Job Status User Guide',
                      label: 'Download',
                      url: 'https://infotrac-stage.infoimageinc.com/staticAssets/job_status_3.0_user_guide.pdf',
                      target: '_blank',
                    },
                    {
                      title: 'Job Status Training Video',
                      label: 'View',
                      url: 'https://www.youtube.com/watch?v=GrohvyoqFBM',
                      target: '_blank',
                    },
                  ],
                },
              ].map(({ categoryName, items }, index, arr) => (
                <Fragment key={crypto.randomUUID()}>
                  <div className="p-4 flex flex-col gap-3">
                    <p className="font-bold">{categoryName}</p>
                    {items.map(({ title, label, target, url }) => (
                      <div key={title}>
                        <p className="text-primary-80 text-sm">{title}</p>
                        <Button size="auto" variant="link" onClick={() => window.open(url, target)}>
                          {label}
                        </Button>
                      </div>
                    ))}
                  </div>
                  {index !== arr.length ? <Separator /> : null}
                </Fragment>
              ))}
            </div>
          </WrapperCard>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
